import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

export const COUNTRY_NAMES = {
  FR: "France", BE: "Belgique", CH: "Suisse", LU: "Luxembourg", MC: "Monaco",
  ES: "Espagne", PT: "Portugal", IT: "Italie", DE: "Allemagne", NL: "Pays-Bas",
  GB: "Royaume-Uni", IE: "Irlande", MA: "Maroc", DZ: "Algérie", TN: "Tunisie",
  SN: "Sénégal", CI: "Côte d'Ivoire", CM: "Cameroun", CD: "RD Congo", GA: "Gabon",
  ML: "Mali", BF: "Burkina Faso", TG: "Togo", BJ: "Bénin", GN: "Guinée",
  MG: "Madagascar", MU: "Maurice", CA: "Canada", US: "États-Unis", MX: "Mexique",
  BR: "Brésil", AR: "Argentine", AE: "Émirats arabes unis", SA: "Arabie saoudite",
  TR: "Turquie", IN: "Inde", ZA: "Afrique du Sud", AU: "Australie",
  AF: "Afghanistan", HT: "Haïti", KM: "Comores", GM: "Gambie", MR: "Mauritanie",
  NG: "Nigeria", PK: "Pakistan", CG: "Congo", LK: "Sri Lanka", NE: "Niger",
  EG: "Égypte", AO: "Angola", TZ: "Tanzanie", UG: "Ouganda", PH: "Philippines",
  ID: "Indonésie", KE: "Kenya", GR: "Grèce", CL: "Chili", RO: "Roumanie",
  PL: "Pologne", KW: "Koweït", MY: "Malaisie", VE: "Venezuela", RU: "Russie",
  KZ: "Kazakhstan", TH: "Thaïlande", CO: "Colombie", QA: "Qatar", LB: "Liban",
  CN: "Chine", VN: "Viêt Nam", JO: "Jordanie", IL: "Israël",
};

export const STATUS_LABELS = {
  active: "Actif", warming: "Préchauffage", paused: "En pause",
  banned: "Banni", disconnected: "Déconnecté", opted_out: "Désinscrit",
  invalid: "Invalide", bounced: "Rejeté", draft: "Brouillon",
  scheduled: "Planifiée", running: "En cours", completed: "Terminée",
  cancelled: "Annulée", pending: "En attente", sent: "Envoyé",
  failed: "Échec", skipped: "Ignoré", blocked: "Bloqué", sending: "Envoi",
};

export const fmt = (n) => new Intl.NumberFormat("fr-FR").format(n ?? 0);

export const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";
